import Select from 'react-select';
// eslint-disable-next-line import/no-extraneous-dependencies
import { map, capitalize } from 'lodash';
import ValidationToast from '@components/toast-validations';
import { validateField } from '@helpers/input-validations';

const {
  i18n: { __ },
  components: { PanelBody },
  data: { withSelect },
  element: { useEffect, useState },
} = wp;

const ClassDropdown = (props) => {
  const {
    setAttributes,
    blockClassNames,
    blockClassPrefix,
    classDropdownLabel = __(`Block Classes`, 'b3rg'),
    initialOpen = true,
    blockClasses,
  } = props;

  const { coreComponentsTheme = {} } = blockClasses || {};

  const [classesList, setClassesList] = useState([]);
  const [defaultDropdownClassValues, setDefaultDropdownClassValues] = useState(
    [],
  );

  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    getElementClasses(
      blockClassPrefix,
      blockClassNames,
      coreComponentsTheme,
      (classes, defaultValues) => {
        setClassesList(classes);
        setDefaultDropdownClassValues(defaultValues);
      },
    );
  }, []); //eslint-disable-line

  return (
    <PanelBody title={classDropdownLabel} initialOpen={initialOpen}>
      <Select
        defaultValue={defaultDropdownClassValues}
        isMulti
        name="blockClasses"
        options={classesList}
        className="basic-multi-select"
        classNamePrefix="select"
        value={blockClassNames}
        onChange={(value) => {
          const isValid = validateField(
            'required',
            'blockClassNames',
            value,
            errors,
            setErrors,
            setShowToast,
          );
          if (isValid) {
            setAttributes({ blockClassNames: value });
          }
        }}
        onBlur={() => {
          setShowToast(false);
        }}
      />
      {showToast && errors.blockClassNames && (
        <ValidationToast type="warning" message={errors.blockClassNames} />
      )}
    </PanelBody>
  );
};

const getElementClasses = (
  blockClassPrefix,
  defaultClasses,
  coreComponentsTheme,
  callback,
) => {
  let classList = [];
  if (
    Array.isArray(coreComponentsTheme[blockClassPrefix]) &&
    coreComponentsTheme[blockClassPrefix].length
  ) {
    classList = coreComponentsTheme[blockClassPrefix].map((className) => {
      const classLabel = className
        .replace(`${blockClassPrefix}--`, '')
        .split('-');
      return { value: className, label: classLabel.map(capitalize).join(' ') };
    });
  }

  const defaultValues = defaultClasses || '';
  callback(classList, defaultValues);
};

export default withSelect((select) => {
  const theme = select('core').getCurrentTheme();
  const { block_classes: blockClasses = {} } = theme || {};
  return { blockClasses };
})(ClassDropdown);

export const getBlockClassNames = (blockClasses) => {
  const classes = map(blockClasses, 'value').join(' ');
  return classes;
};
